// Quiet single-line footer. Schist text on Limestone. No "made with love."
// Social presence is a centered row of icon-only brand links — FA6 brands is
// the one pack carrying all four accounts plus GitHub in one consistent set.

import { FaGithub, FaLinkedinIn, FaTiktok, FaXTwitter, FaYoutube } from 'react-icons/fa6'

// Add or change an account by editing this list. `label` becomes the link's
// aria-label (the accessible name, since links are icon-only), `href` is the
// canonical https profile, and `Icon` is a Font Awesome 6 brand glyph.
const socialLinks = [
  { label: 'GitHub', href: 'https://github.com/cairntools/cairn', Icon: FaGithub },
  { label: 'X', href: 'https://x.com/sisubuilt', Icon: FaXTwitter },
  { label: 'YouTube', href: 'https://www.youtube.com/@sisubuilt', Icon: FaYoutube },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/sisubuilt/', Icon: FaLinkedinIn },
  { label: 'TikTok', href: 'https://www.tiktok.com/@sisubuilt', Icon: FaTiktok },
]

export function MarketingFooter() {
  return (
    <footer className="mt-32 border-t border-[var(--color-sandstone)]">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-6 py-8 text-xs text-[var(--color-schist)]">
        <div className="flex w-full flex-wrap items-center justify-between gap-x-5 gap-y-1">
          <a href="mailto:hello@cairntools.com" className="hover:text-[var(--color-terracotta)]">
            hello@cairntools.com
          </a>
          <span>Free during beta</span>
        </div>
        <nav aria-label="Social" className="flex items-center justify-center gap-5">
          {socialLinks.map(({ label, href, Icon }) => (
            <a
              key={label}
              href={href}
              aria-label={label}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--color-schist)] transition-colors hover:text-[var(--color-terracotta)]"
            >
              <Icon className="size-4" aria-hidden="true" focusable="false" />
            </a>
          ))}
        </nav>
        <span>© Cairn Tools</span>
      </div>
    </footer>
  )
}
